import axios from 'axios';

// Choose HTTPS unless explicitly debugging with HTTP
const api = axios.create({
    baseURL: '/api',
    withCredentials: true,     // ← must match server’s AllowCredentials
    headers: { 'Content-Type': 'application/json' },
});

// Helper to set/remove JWT from headers
export const setAuthToken = (token: string | null) => {
    if (token) {
        api.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    } else {
        delete api.defaults.headers.common['Authorization'];
    }
};

export default api;
